import { render, staticRenderFns } from "./ListAdminContact.vue?vue&type=template&id=d1254c18&lang=pug"
import script from "./ListAdminContact.vue?vue&type=script&lang=js"
export * from "./ListAdminContact.vue?vue&type=script&lang=js"
import style0 from "./ListAdminContact.vue?vue&type=style&index=0&id=d1254c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports